import(/* webpackMode: "eager" */ "/app/src/app/compare/gamma/page.tsx");
